import tenant from './tenant'
import account from './account'
import role from './role'
export default {
  tenant,
  account,
  role
}
